import {RoomShareNote} from "@/core/api/room.shareNote.api";
import {roomShareNoteService} from "@/core/service/room.shareNote.service";

export default {
    shareNoteLogList: async ({ dispatch, commit, getters, rootGetters }) => {
        let list = await RoomShareNote.getRoomShareNoteLogList();
        return list;
    },

    getShareNoteLog: async ({ dispatch, commit, getters, rootGetters }, {noteId}) => {
        let list = await RoomShareNote.getRoomShareNoteLogList();
        let note = list.find(note => note.noteId === noteId);
        return note;
    },

    getShareNoteLogData: async ({ dispatch, commit, getters, rootGetters }, {noteId}) => {
        let data = await RoomShareNote.getRoomShareNoteLogData({noteId});
        return data;
    },

    changeRoomShareNote: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId, noteId}) => {
        return await roomShareNoteService.changeNote({roomGroupId, noteId});
    }
}
